import React from "react";
import AdinkraMark from "@/components/AdinkraMark";

export default function SiteFooter() {
  return (
    <footer className="no-print relative bg-purple-deep velvet text-white/70 py-14 overflow-hidden" data-testid="site-footer">
      <AdinkraMark
        symbol="sankofa"
        className="absolute text-gold pointer-events-none left-1/2 top-1/2"
        style={{ width: "280px", height: "280px", transform: "translate(-50%,-50%)", opacity: 0.05 }}
      />
      <div className="relative z-10 max-w-3xl mx-auto px-6 text-center">
        <span className="w-20 h-20 rounded-2xl bg-cream ring-1 ring-gold/40 mx-auto mb-6 flex items-center justify-center overflow-hidden shadow-[0_10px_30px_rgba(0,0,0,0.3)]">
          <img src="/brand/oxytocin-logo.png" alt="Oxytocin-Learning Ltd" className="w-16 h-16 object-contain" />
        </span>
        <p className="text-[13px] leading-relaxed text-white/75">
          Oxytocin-Learning Ltd is a CPD-accredited training provider, accredited by The CPD Standards Office,
          an independent CPD accreditation body. Provider No. 51109.
        </p>
        <p className="text-[12px] leading-relaxed text-white/55 mt-3">
          CPD-aligned learning · Adinkra symbols are cultural marks, named wherever they appear.
        </p>
        <p className="text-[11px] uppercase tracking-[0.22em] text-gold-pale mt-6">Forward Ever, Backward Never</p>
      </div>
    </footer>
  );
}
